import { render, staticRenderFns } from "./HKLButton.vue?vue&type=template&id=f1ab3a24&scoped=true&"
import script from "./HKLButton.vue?vue&type=script&lang=js&"
export * from "./HKLButton.vue?vue&type=script&lang=js&"
import style0 from "./HKLButton.vue?vue&type=style&index=0&id=f1ab3a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ab3a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ab3a24')) {
      api.createRecord('f1ab3a24', component.options)
    } else {
      api.reload('f1ab3a24', component.options)
    }
    module.hot.accept("./HKLButton.vue?vue&type=template&id=f1ab3a24&scoped=true&", function () {
      api.rerender('f1ab3a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Button/HKLButton.vue"
export default component.exports